import { Card, CardContent, Checkbox, FormControlLabel, Typography } from '@mui/material';

export default function CouponCompatibility({ coupon, onChange }) {
    const isBtl = coupon.source === 'btl';
    const combines = !isBtl && coupon.combine_with_promotions !== false;
    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }} gutterBottom>
                    Compatibilidad con promociones
                </Typography>
                <FormControlLabel
                    control={<Checkbox name="combine_with_promotions" checked={combines}
                        disabled={isBtl} onChange={event => onChange(event.target.checked)} />}
                    label="Combinar este cupón con promociones de productos"
                />
                <Typography variant="body2" color="text.secondary">
                    {combines
                        ? 'Se conservan las promociones y después se aplica el beneficio del cupón.'
                        : 'Al aplicar el cupón se retiran las promociones de todo el carrito y sus topes de piezas. Se conserva el límite por existencias.'}
                </Typography>
                <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1 }}>
                    Solo se permite un cupón por pedido. Al aplicar cualquier cupón se pierde el envío gratis
                    por monto mínimo; únicamente un cupón de envío gratis concede ese beneficio.
                </Typography>
            </CardContent>
        </Card>
    );
}
